import { Component, ChangeDetectionStrategy } from '@angular/core'
import { ModalService } from '@/services/modal.service'
import { LogoutModalComponent } from './logout-modal.component'
import { DefaultModalComponent } from './default-modal.component'
import { LoginModalComponent } from './login-modal.component'
import { TakenOverModalComponent } from './taken-over-modal.component'
import { ResetPasswordModalComponent } from './reset-password-modal.component'

@Component({
	selector: 'app-modals',
	imports: [
		LogoutModalComponent,
		DefaultModalComponent,
		LoginModalComponent,
		TakenOverModalComponent,
		ResetPasswordModalComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<!-- Use @if to toggle visibility of different modals -->
		@if (modalService.getVisible('default')()) {
			<default-modal />
		}
		@if (modalService.getVisible('logout')()) {
			<logout-modal />
		}
		@if (modalService.getVisible('login')()) {
			<login-modal />
		}
		@if (modalService.getVisible('takenOver')()) {
			<taken-over-modal />
		}
		@if (modalService.getVisible('resetPassword')()) {
			<reset-password-modal />
		}
	`
})
export class ModalsComponent {
	constructor(public modalService: ModalService) {}
}
